export default __webpack_public_path__ + "static/media/adblocker.6947054d.svg";